import React, { useEffect, useState, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../../../app/Api/ApiSlice";
import { toast } from "react-toastify";
import { FaPlus, FaSearch } from "react-icons/fa";
import UserImage from "../../../assets/user.png";
import Loader from "../../../components/Loader";

const AddAdmins = () => {
    const { name } = useParams();

    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [addingId, setAddingId] = useState(null);

    // =============================
    // Fetch candidate users
    // =============================
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                setIsLoading(true);

                const res = await api.get(`/stores/${name}/manage/admins/new`);
                setUsers(res.data || []);
            } catch (error) {
                toast.error(error?.response?.data?.message || "Failed to load users");
            } finally {
                setIsLoading(false);
            }
        };

        fetchUsers();
    }, [name]);

    // =============================
    // Add admin
    // =============================
    const handleAdd = async (id) => {
        try {
            setAddingId(id);

            await api.post(`/stores/${name}/manage/admins`, { id });

            // remove from list (clean UX)
            setUsers((prev) => prev.filter((u) => u._id !== id));

            toast.success("Admin added");
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to add admin");
        } finally {
            setAddingId(null);
        }
    };

    // =============================
    // Search filter (client side)
    // =============================
    const filteredUsers = useMemo(() => {
        if (!search) return users;

        return users.filter((u) =>
            `${u.firstname} ${u.lastname}`
                .toLowerCase()
                .includes(search.toLowerCase())
        );
    }, [search, users]);

    // =============================
    // UI
    // =============================
    return (
        <div className="shop-admins">
            <div className="admins-page-header">
                <h2 className="store-name">{name}</h2>
                <p className="page-title">Add Admins</p>
            </div>

            {/* Search */}
            <div className="search-user-form">
                <input
                    type="text"
                    placeholder="Search user..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <button type="button">
                    <FaSearch />
                </button>
            </div>

            {/* List */}
            <div className="admins-list">
                {filteredUsers.map((user) => (
                    <div className="admin-card-container" key={user._id}>
                        <Link to={`/user/${user._id}`}>
                            <div className="admin-card-details">
                                <div className="admin-card-profile-image">
                                    <img
                                        src={user?.profilePic?.url || UserImage}
                                        alt=""
                                    />
                                </div>

                                <div className="user-profile-name">
                                    <p className="user-card-name">
                                        {user.firstname} {user.lastname}
                                    </p>
                                </div>
                            </div>
                        </Link>

                        <div
                            className="admin-chat-btn"
                            onClick={() => handleAdd(user._id)}
                            style={{ opacity: addingId === user._id ? 0.6 : 1 }}
                        >
                            {addingId === user._id ? "Adding..." : <><FaPlus /> <p>Add</p></>}
                        </div>
                    </div>
                ))}
            </div>

            {isLoading && <Loader />}
        </div>
    );
};

export default AddAdmins;
